import { type ItemPricing, type OrderPricing, type Pricing } from '~shared/features/pricing/types';
import { type APIError } from '~shared/types/APIError';

export const SET_PRESCRIPTION_PRICING = 'SET_PRESCRIPTION_PRICING';
export type SetPrescriptionPricing = {
  type: typeof SET_PRESCRIPTION_PRICING;
  payload: ItemPricing;
};

// Networking for prescription pricing now lives in React Query (useGetPrescriptionPricing).
// This setter only mirrors the fetched data into the Redux pricing slice so the existing
// pricing selectors keep working — the transitional bridge step toward strategy A.
// See the redux-thunk-to-react-query-migration skill.
export function setPrescriptionPricing(prescriptionPricing: ItemPricing): SetPrescriptionPricing {
  return {
    type: SET_PRESCRIPTION_PRICING,
    payload: prescriptionPricing,
  };
}

export const FETCH_ORDER_PRICING_LOADING = 'FETCH_ORDER_PRICING_LOADING';
type ActionFetchingOrderPricing = {
  type: typeof FETCH_ORDER_PRICING_LOADING;
};
export function fetchingOrderPricing(): ActionFetchingOrderPricing {
  return {
    type: FETCH_ORDER_PRICING_LOADING,
  };
}

export type OrderPricingAPIResponse = Omit<OrderPricing, 'item_pricing' | 'shipment_id'> & { item_pricing: Pricing[] };

export const FETCH_ORDER_PRICING_SUCCEEDED = 'FETCH_ORDER_PRICING_SUCCEEDED';
type FetchOrderPricingSucceededPayload = OrderPricingAPIResponse & {
  isShipmentPricing: boolean;
  isEditPricing: boolean;
};
export type ActionFetchOrderPricingSucceeded = {
  type: typeof FETCH_ORDER_PRICING_SUCCEEDED;
  payload: FetchOrderPricingSucceededPayload;
};
export function fetchOrderPricingSucceeded(
  orderPricing: FetchOrderPricingSucceededPayload,
): ActionFetchOrderPricingSucceeded {
  return {
    type: FETCH_ORDER_PRICING_SUCCEEDED,
    payload: orderPricing,
  };
}

export const FETCH_ORDER_PRICING_FAILED = 'FETCH_ORDER_PRICING_FAILED';
export type ActionFetchOrderPricingFailed = {
  type: typeof FETCH_ORDER_PRICING_FAILED;
  payload: APIError;
  error: true;
};
export function fetchOrderPricingFailed(error: APIError): ActionFetchOrderPricingFailed {
  return {
    type: FETCH_ORDER_PRICING_FAILED,
    payload: error,
    error: true,
  };
}

type OrderActions = ActionFetchingOrderPricing | ActionFetchOrderPricingFailed | ActionFetchOrderPricingSucceeded;

export type PricingActions = SetPrescriptionPricing | OrderActions;
